import type { IconSvgObject } from './types';

const GalleryHorizontalIcon: IconSvgObject = [
  ["path", { d: "M2 6V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 3H15C12.643 3 11.4645 3 10.7322 3.73223C10 4.46447 10 5.64298 10 8V16C10 18.357 10 19.5355 10.7322 20.2678C11.4645 21 12.643 21 15 21H17C19.357 21 20.5355 21 21.2678 20.2678C22 19.5355 22 18.357 22 16V8C22 5.64298 22 4.46447 21.2678 3.73223C20.5355 3 19.357 3 17 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 4V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default GalleryHorizontalIcon;
